const Color = {
  background: {
    primary: "#78c043", // Brand main color //Typtap green
    secondary: "#199ee1", // Brand second color //Typtap blue
    tilesPrimary: "#78c043", // Green
    tilesSecondary: "#289dd8", // Blue
    white: "#ffffff",
    black: "#000000",
    textGray: "#5e5e5e", // Using for all gray text and gray border with 60% opacity
    bgGray: "#4e4e4e",
    alertMessage: "#4e4e4e",
    navigationBar: "#f8f8f8",
    errorRed: "#ffbebe",
    warningRed: "#ff6589",
    infoBanner: "#0a3348",
  },
  navigation: {
    headerBg: "#4C9319",
  },
  header: {
    subHeader: "#51842d",
  },
  button: {
    btnGreen: "#2196f3",
    btnPrimary: "#2196f3",
    btnRed: "#d24d57",
  },
  loader: {
    background: "rgba(0, 0, 0, 0.5)",
  },
  notification: {
    read: "#000",
    unread: "#2196f3",
  },
  policyStatus: {
    generic: "#2c793e",
    first: "#338B47",
    second: "#C99C37",
    third: "#B55453",
  },
};

export default Color;
